import { Chip } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function PublicFundingNewBadge() {
  const { t } = useTranslation(
    "client\\components\\nav\\PublicFundingNewBadge",
  );

  return (
    <Chip
      color="primary"
      data-test-id="public-funding-new-badge"
      label={t("New")}
      size="small"
      sx={{
        height: "1.5em",
        marginLeft: "0.5em",
        "& .MuiChip-label": {
          fontSize: "1em",
          fontWeight: 700,
          paddingX: "0.25em",
        },
      }}
    />
  );
}
